export class RulesLabelModel {
  id: number;
  cleansingMethod: string;
  labelName: string;
  inputType: string;

  constructor(id: number, cleansingMethod: string, labelName: string, inputType: string) {
    this.id = id;
    this.cleansingMethod = cleansingMethod;
    this.labelName = labelName;
    this.inputType = inputType;
  }
}
